import { render, staticRenderFns } from "./CustomerDashboardView.vue?vue&type=template&id=3ce7c2b3&"
import script from "./CustomerDashboardView.vue?vue&type=script&lang=js&"
export * from "./CustomerDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDashboardView.vue?vue&type=style&index=0&id=3ce7c2b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports